import React, { Fragment, useContext } from "react";
import { Container, Row, Col } from "reactstrap";
import { CSSTransition } from 'react-transition-group';

import useIsInViewport from "ui/hooks/inViewport";

import { ThemeContext } from "../../context/ThemeContext";

const VerticalGetAll = () => {
    const context = useContext( ThemeContext );
    const [inView1, header1] = useIsInViewport();

    return (
        <Fragment>
            <section className={"upward_vertical_getall " + (context ? "upward_vertical_getall_" + context : "") }>
                <Container>
                    <CSSTransition in={inView1} timeout={200} classNames="fade-effect" ><h3 ref={header1}>You get all the above...<br /> and more!</h3></CSSTransition>
                    <Row noGutters>
                        <Col lg="6" className="upward_vertical_getall_wrapper">
                            <div className="clearfix">
                                <div className="upward_vertical_getall_header">
                                    <h4>communicate</h4>
                                </div>
                                <div className="upward_vertical_getall_description">
                                    <p>Communicate directly with candidates with our messaging platform.</p>
                                </div>
                            </div>
                        </Col>
                        <Col lg="6" className="upward_vertical_getall_wrapper">
                            <div className="clearfix">
                                <div className="upward_vertical_getall_header">
                                    <h4>budget</h4>
                                </div>
                                <div className="upward_vertical_getall_description">
                                    <p>Only pay when you need to hire. No messy subscription fees. Just pay-as-you-go.</p>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row noGutters>
                        <Col lg="6" className="upward_vertical_getall_wrapper">
                            <div className="clearfix">
                                <div className="upward_vertical_getall_header">
                                    <h4>manage</h4>
                                </div>
                                <div className="upward_vertical_getall_description">
                                    <p>Manage and rate candidates in one central place.</p>
                                </div>
                            </div>
                        </Col>
                        <Col lg="6" className="upward_vertical_getall_wrapper">
                            <div className="clearfix">
                                <div className="upward_vertical_getall_header">
                                    <h4>promote</h4>
                                </div>
                                <div className="upward_vertical_getall_description">
                                    <p>Sponsor jobs and post directly to premium boards to get more candidates.</p>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row noGutters>
                        <Col lg="6" className="upward_vertical_getall_wrapper">
                            <div className="clearfix">
                                <div className="upward_vertical_getall_header">
                                    <h4>templatize</h4>
                                </div>
                                <div className="upward_vertical_getall_description">
                                    <p>Pre-made job description templates that convert. Easy to quickly customize and post.</p>
                                </div>
                            </div>
                        </Col>
                        <Col lg="6" className="upward_vertical_getall_wrapper">
                            <div className="clearfix">
                                <div className="upward_vertical_getall_header">
                                    <h4>qualify</h4>
                                </div>
                                <div className="upward_vertical_getall_description">
                                    <p>Add filtering questions to only get the candidates you want.</p>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </Fragment>
    )
}

export default VerticalGetAll;